import {useState} from 'react';
import type {EventUpsellType} from '@Libraries/events.library';
import {openEventsUpsellDialog} from '@Libraries/events.library';

export interface EventsUpsellDialog {
  isUpsellDialogLoading: boolean;
  openUpsellDialog: (upsellType: EventUpsellType) => void;
}

export const useEventsUpsellDialog = (): EventsUpsellDialog => {
  const [isUpsellDialogLoading, setIsUpsellDialogLoading] = useState(false);

  const openUpsellDialog = (upsellType: EventUpsellType): void => {
    setIsUpsellDialogLoading(true);
    openEventsUpsellDialog(upsellType, {
      onDialogLoaded: (): void => {
        setIsUpsellDialogLoading(false);
      },
    });
  };

  return {isUpsellDialogLoading, openUpsellDialog};
};
